import { render, staticRenderFns } from "./cargo_item_2.vue?vue&type=template&id=fed311ca&scoped=true"
import script from "./cargo_item_2.vue?vue&type=script&lang=js"
export * from "./cargo_item_2.vue?vue&type=script&lang=js"
import style0 from "./cargo_item_2.vue?vue&type=style&index=0&id=fed311ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed311ca",
  null
  
)

export default component.exports